import { useEffect, useState } from "react";

const seed = () => {
  const buy = Math.random() > 0.48;
  const r = Math.random();
  const size = r > 0.93 ? 8 + Math.random() * 40 : r > 0.75 ? 1 + Math.random() * 6 : Math.random();
  return { id: Math.random(), buy, size, px: 80800 + Math.round((Math.random() - 0.5) * 120), joined: Math.random() > 0.8 ? 2 + Math.floor(Math.random() * 6) : 0 };
};

export const SmartTapeMock = () => {
  const [rows, setRows] = useState(() => Array.from({ length: 13 }, seed));
  useEffect(() => {
    const t = setInterval(() => setRows((r) => [seed(), ...r.slice(0, 12)]), 650);
    return () => clearInterval(t);
  }, []);
  const buys = rows.filter((r) => r.buy).length;
  return (
    <div data-testid="smart-tape-mock" className="bg-[#0A0B0D] font-mono text-[11px]">
      <div className="flex items-center justify-between border-b border-white/[0.06] px-4 py-3">
        <div className="flex gap-1.5">
          {["All", "Large", "Whale"].map((f, i) => (
            <span key={f} className={`border px-2.5 py-1 uppercase tracking-[0.15em] text-[10px] ${i === 0 ? "border-white/25 text-[#ECEBE4]" : "border-white/[0.08] text-[#5A6170]"}`}>{f}</span>
          ))}
        </div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-[#5A6170]">
          Aggression 10s
          <span className="relative h-1 w-20 overflow-hidden bg-[#FF4D5A]/60">
            <span className="absolute inset-y-0 left-0 bg-[#BACD1C]/80 transition-[width] duration-500" style={{ width: `${(buys / rows.length) * 100}%` }} />
          </span>
        </div>
      </div>
      <div className="grid grid-cols-[1.2fr_1fr_0.8fr_84px] gap-x-4 border-b border-white/[0.04] px-4 py-2 text-[9px] uppercase tracking-[0.18em] text-[#5A6170]">
        <span>Price</span><span>Size · BTC</span><span>Side</span><span className="text-right">Joined</span>
      </div>
      <div className="h-[360px] overflow-hidden">
        {rows.map((r) => (
          <div key={r.id} className={`grid grid-cols-[1.2fr_1fr_0.8fr_84px] gap-x-4 px-4 py-[7px] tabular-nums animate-[fadeIn_.4s_ease] ${r.size > 8 ? (r.buy ? "bg-[#BACD1C]/[0.07]" : "bg-[#FF4D5A]/[0.08]") : ""}`}>
            <span className="text-[#ECEBE4]">{r.px.toLocaleString()}.0</span>
            <span className={r.size > 8 ? "font-bold text-[#ECEBE4]" : "text-[#9DA3AE]"}>{r.size.toFixed(3)}</span>
            <span className={r.buy ? "text-[#BACD1C]/80" : "text-[#FF4D5A]/90"}>{r.buy ? "BUY" : "SELL"}</span>
            <span className="text-right text-[#5A6170]">{r.joined ? `${r.joined} prints` : "·"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
